import React from 'react'
import {Redirect, Route} from 'react-router-dom'

const AuthenticationRoute = ({component: Component, componentProps: {...comProps}, authenticated, ...rest}) => {

    return (<Route {...rest} render={routeprops => (
        
        !authenticated ? (
            <Component {...comProps} {...routeprops} />
        ) : (
            <Redirect to={{
                pathname: '/',
                state: {from: routeprops.location}
            }}/>
        )
    )}/>)
}

export default AuthenticationRoute



// WEBPACK FOOTER //
// ./src/components/AuthenticationRoute.js